(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-collection-carousel"] && !Shopify.designMode) return;
  try {
    
  class WristoeTabbedCarousel {
    constructor(root) {
      this.root = root;
      this.buttons = Array.from(root.querySelectorAll('.wristoe-tab-button'));
      this.panels = Array.from(root.querySelectorAll('.wristoe-tabbed-carousel__panel'));

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.activate(button));
      });
    }

    activate(activeButton) {
      const targetId = activeButton.dataset.tabTarget;

      this.buttons.forEach((button) => {
        const isActive = button === activeButton;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.panels.forEach((panel) => {
        const isActive = panel.id === targetId;
        panel.classList.toggle('is-active', isActive);
        panel.toggleAttribute('hidden', !isActive);
      });
    }
  }

  document.querySelectorAll('.wristoe-tabbed-carousel').forEach((root) => {
    new WristoeTabbedCarousel(root);
  });

  } catch(e) { console.error(e); }
})();
})();
